document.addEventListener('DOMContentLoaded', () => {
  console.log('[Final Sale] Script loaded - DOMContentLoaded fired');
  
  const productForm = document.querySelector('.product-single__form');
  console.log('[Final Sale] Product form found:', productForm);
  
  if (!productForm) {
    console.log('[Final Sale] No product form found, exiting');
    return;
  }

  // Find the variant select and variants JSON
  const variantSelect = productForm.querySelector('.product-single__variants.no-js');
  const variantsJsonEl = productForm.querySelector('[id^="VariantsJson-"]');
  const saleColorsJsonEl = productForm.querySelector('[id^="SaleColorsJson-"]');
  const finalSaleSpan = productForm.querySelector('[id^="FinalSale-"]');
  
  console.log('[Final Sale] Elements found:', {
    variantSelect: !!variantSelect,
    variantsJsonEl: !!variantsJsonEl,
    saleColorsJsonEl: !!saleColorsJsonEl,
    finalSaleSpan: !!finalSaleSpan
  });
  
  if (!variantSelect || !variantsJsonEl || !finalSaleSpan) {
    console.log('[Final Sale] Missing required elements, exiting');
    return;
  }

  // Get section ID from the select ID
  const sectionId = variantSelect.id.replace('ProductSelect-', '');
  console.log('[Final Sale] Section ID:', sectionId);
  
  // Parse variants JSON
  let variants = [];
  try {
    variants = JSON.parse(variantsJsonEl.textContent);
    console.log('[Final Sale] Variants parsed successfully. Total variants:', variants.length);
  } catch (e) {
    console.error('[Final Sale] Error parsing variants JSON:', e);
    return;
  }

  // Parse sale colors JSON
  let saleColors = [];
  if (saleColorsJsonEl) {
    console.log('[Final Sale] SaleColorsJson element found');
    console.log('[Final Sale] SaleColorsJson textContent:', saleColorsJsonEl.textContent);
    console.log('[Final Sale] SaleColorsJson textContent trimmed:', saleColorsJsonEl.textContent.trim());
    
    if (saleColorsJsonEl.textContent.trim()) {
      try {
        const saleColorsData = JSON.parse(saleColorsJsonEl.textContent);
        console.log('[Final Sale] Sale colors data parsed:', saleColorsData);
        console.log('[Final Sale] Sale colors data type:', typeof saleColorsData);
        console.log('[Final Sale] Is array?', Array.isArray(saleColorsData));
        
        // Handle both array and null/undefined cases
        saleColors = Array.isArray(saleColorsData) ? saleColorsData : [];
        console.log('[Final Sale] Final saleColors array:', saleColors);
      } catch (e) {
        console.error('[Final Sale] Error parsing sale colors JSON:', e);
        console.error('[Final Sale] Error details:', e.message);
        saleColors = [];
      }
    } else {
      console.log('[Final Sale] SaleColorsJson textContent is empty');
    }
  } else {
    console.log('[Final Sale] SaleColorsJson element not found');
  }
  
  console.log('[Final Sale] Final saleColors:', saleColors);

  // Function to get selected variant from option buttons (works for unavailable variants too)
  const getSelectedVariant = () => {
    console.log('[Final Sale] getSelectedVariant called');
    
    // First try to get from select (for available variants)
    const selectValue = variantSelect.value;
    console.log('[Final Sale] Select value:', selectValue);
    
    if (selectValue) {
      const variantFromSelect = variants.find(v => v.id === parseInt(selectValue));
      if (variantFromSelect) {
        console.log('[Final Sale] Variant found from select:', variantFromSelect);
        return variantFromSelect;
      }
    }
    
    // If not found in select, find by option values from radio buttons
    const variantWrappers = productForm.querySelectorAll('.variant-wrapper');
    const selectedOptions = [];
    
    variantWrappers.forEach(wrapper => {
      const checkedInput = wrapper.querySelector('input[type="radio"]:checked');
      if (checkedInput) {
        selectedOptions.push(checkedInput.value);
      }
    });
    
    console.log('[Final Sale] Selected options from radio buttons:', selectedOptions);
    
    // Find variant matching the selected options
    if (selectedOptions.length > 0) {
      const matchingVariant = variants.find(v => {
        const variantOptions = [v.option1, v.option2, v.option3].filter(Boolean);
        if (variantOptions.length !== selectedOptions.length) {
          return false;
        }
        return variantOptions.every((opt, index) => opt === selectedOptions[index]);
      });
      
      if (matchingVariant) {
        console.log('[Final Sale] Variant found from radio buttons:', matchingVariant);
        return matchingVariant;
      }
    }
    
    console.log('[Final Sale] No variant found');
    return null;
  };

  // Function to get selected color from radio buttons
  const getSelectedColor = () => {
    // Try fieldset with name="Color" first
    const colorFieldset = productForm.querySelector('fieldset[name="Color"]');
    console.log('[Final Sale] Color fieldset found:', !!colorFieldset);
    
    if (colorFieldset) {
      const checkedColorInput = colorFieldset.querySelector('input[type="radio"]:checked');
      console.log('[Final Sale] Checked color input found:', !!checkedColorInput);
      
      if (checkedColorInput) {
        const colorValue = checkedColorInput.value;
        console.log('[Final Sale] Selected color:', colorValue);
        return colorValue;
      }
    }
    
    // Fallback: try to find variant-wrapper with Color option
    const variantWrappers = productForm.querySelectorAll('.variant-wrapper');
    for (let wrapper of variantWrappers) {
      const fieldset = wrapper.querySelector('fieldset[name="Color"]');
      if (fieldset) {
        const checkedColorInput = fieldset.querySelector('input[type="radio"]:checked');
        if (checkedColorInput) {
          const colorValue = checkedColorInput.value;
          console.log('[Final Sale] Selected color (from wrapper):', colorValue);
          return colorValue;
        }
      }
    }
    
    console.log('[Final Sale] No color selected');
    return null;
  };

  // Function to check if selected color has m-meta class
  const hasMetaClass = () => {
    // Try fieldset with name="Color" first
    const colorFieldset = productForm.querySelector('fieldset[name="Color"]');
    
    if (colorFieldset) {
      const checkedColorInput = colorFieldset.querySelector('input[type="radio"]:checked');
      if (checkedColorInput) {
        const variantInput = checkedColorInput.closest('.variant-input');
        console.log('[Final Sale] Variant input found:', !!variantInput);
        
        if (variantInput) {
          const hasClass = variantInput.classList.contains('m-meta');
          console.log('[Final Sale] Variant input classes:', variantInput.className);
          console.log('[Final Sale] Has m-meta class?', hasClass);
          
          if (hasClass) {
            return true;
          }
        }
      }
    }
    
    // Fallback: try to find variant-wrapper with Color option
    const variantWrappers = productForm.querySelectorAll('.variant-wrapper');
    for (let wrapper of variantWrappers) {
      const fieldset = wrapper.querySelector('fieldset[name="Color"]');
      if (fieldset) {
        const checkedColorInput = fieldset.querySelector('input[type="radio"]:checked');
        if (checkedColorInput) {
          const variantInput = checkedColorInput.closest('.variant-input');
          if (variantInput && variantInput.classList.contains('m-meta')) {
            console.log('[Final Sale] Has m-meta class (from wrapper)');
            return true;
          }
        }
      }
    }
    
    console.log('[Final Sale] No m-meta class found');
    return false;
  };

  // Function to update Final Sale visibility
  const updateFinalSaleVisibility = () => {
    console.log('[Final Sale] ===== updateFinalSaleVisibility called =====');
    
    const selectedVariant = getSelectedVariant();
    const selectedColor = getSelectedColor();
    
    console.log('[Final Sale] Selected variant:', selectedVariant);
    console.log('[Final Sale] Selected color:', selectedColor);
    
    let shouldShow = false;
    
    // Check if variant has compare_at_price > 0
    // Handle empty string, null, and string values
    if (selectedVariant) {
      console.log('[Final Sale] Variant compare_at_price value:', selectedVariant.compare_at_price);
      console.log('[Final Sale] Variant compare_at_price type:', typeof selectedVariant.compare_at_price);
      
      if (selectedVariant.compare_at_price) {
        const comparePrice = parseFloat(selectedVariant.compare_at_price) || 0;
        console.log('[Final Sale] Compare price:', selectedVariant.compare_at_price, '-> parsed:', comparePrice);
        
        if (comparePrice > 0) {
          console.log('[Final Sale] ✓ Condition 1: compare_at_price > 0 is TRUE');
          shouldShow = true;
        } else {
          console.log('[Final Sale] ✗ Condition 1: compare_at_price > 0 is FALSE (value is 0 or empty)');
        }
      } else {
        console.log('[Final Sale] ✗ Condition 1: compare_at_price is falsy (null, undefined, empty string, or 0)');
      }
    } else {
      console.log('[Final Sale] ✗ Condition 1: No variant found');
    }
    
    // Check if selected color is in sale_colors array
    if (!shouldShow && selectedColor && saleColors.length > 0) {
      console.log('[Final Sale] Checking condition 2: color in sale_colors array');
      console.log('[Final Sale] Sale colors array:', saleColors);
      console.log('[Final Sale] Selected color:', selectedColor);
      console.log('[Final Sale] Color in array?', saleColors.includes(selectedColor));
      
      if (saleColors.includes(selectedColor)) {
        console.log('[Final Sale] ✓ Condition 2: color in sale_colors is TRUE');
        shouldShow = true;
      } else {
        console.log('[Final Sale] ✗ Condition 2: color in sale_colors is FALSE');
      }
    } else {
      console.log('[Final Sale] ✗ Condition 2: Skipped - shouldShow:', shouldShow, 'selectedColor:', selectedColor, 'saleColors.length:', saleColors.length);
    }
    
    // Check if selected color has m-meta class
    if (!shouldShow) {
      console.log('[Final Sale] Checking condition 3: m-meta class');
      const hasMeta = hasMetaClass();
      
      if (hasMeta) {
        console.log('[Final Sale] ✓ Condition 3: m-meta class is TRUE');
        shouldShow = true;
      } else {
        console.log('[Final Sale] ✗ Condition 3: m-meta class is FALSE');
      }
    } else {
      console.log('[Final Sale] ✗ Condition 3: Skipped (already shouldShow = true)');
    }
    
    // Show or hide Final Sale span
    console.log('[Final Sale] Final decision - shouldShow:', shouldShow);
    if (shouldShow) {
      console.log('[Final Sale] Showing Final Sale span');
      finalSaleSpan.style.display = 'block';
    } else {
      console.log('[Final Sale] Hiding Final Sale span');
      finalSaleSpan.style.display = 'none';
    }
    
    console.log('[Final Sale] ===== updateFinalSaleVisibility complete =====');
  };

  // Set initial state
  console.log('[Final Sale] Setting initial state');
  updateFinalSaleVisibility();

  // Listen for variant select changes
  console.log('[Final Sale] Adding change listener to variant select');
  variantSelect.addEventListener('change', () => {
    console.log('[Final Sale] Variant select changed event fired');
    updateFinalSaleVisibility();
  });

  // Also listen for variant button changes (for color/size buttons)
  const variantInputs = productForm.querySelectorAll('.variant-input input[type="radio"]');
  console.log('[Final Sale] Found variant radio inputs:', variantInputs.length);
  variantInputs.forEach((input, index) => {
    input.addEventListener('change', () => {
      console.log(`[Final Sale] Variant radio input ${index} changed:`, input.value);
      // Delay to ensure variant selection is complete
      setTimeout(() => {
        console.log('[Final Sale] Timeout fired after radio change');
        updateFinalSaleVisibility();
      }, 200);
    });
  });

  // Listen for clicks on variant buttons (labels/divs) as well
  const variantButtons = productForm.querySelectorAll('.variant-input');
  console.log('[Final Sale] Found variant buttons:', variantButtons.length);
  variantButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
      console.log(`[Final Sale] Variant button ${index} clicked`);
      // Delay to ensure variant selection is complete
      setTimeout(() => {
        console.log('[Final Sale] Timeout fired after button click');
        updateFinalSaleVisibility();
      }, 200);
    });
  });

  // Listen for variantChange event from theme.js (if jQuery is available)
  const productContainer = productForm.closest('.product-single');
  console.log('[Final Sale] Product container found:', !!productContainer);
  console.log('[Final Sale] jQuery available:', typeof jQuery !== 'undefined');
  
  if (productContainer && typeof jQuery !== 'undefined') {
    console.log('[Final Sale] Setting up jQuery variantChange listener');
    jQuery(productContainer).on('variantChange', function(event, variant) {
      console.log('[Final Sale] ===== jQuery variantChange event fired =====');
      console.log('[Final Sale] Variant from event:', variant);
      
      const selectedColor = getSelectedColor();
      let shouldShow = false;
      
      // Check if variant has compare_at_price > 0
      // Handle empty string, null, and string values
      if (variant) {
        console.log('[Final Sale] jQuery - Variant compare_at_price value:', variant.compare_at_price);
        console.log('[Final Sale] jQuery - Variant compare_at_price type:', typeof variant.compare_at_price);
        
        if (variant.compare_at_price) {
          const comparePrice = parseFloat(variant.compare_at_price) || 0;
          console.log('[Final Sale] jQuery - Compare price:', variant.compare_at_price, '-> parsed:', comparePrice);
          
          if (comparePrice > 0) {
            console.log('[Final Sale] jQuery - ✓ Condition 1: compare_at_price > 0 is TRUE');
            shouldShow = true;
          } else {
            console.log('[Final Sale] jQuery - ✗ Condition 1: compare_at_price > 0 is FALSE (value is 0 or empty)');
          }
        } else {
          console.log('[Final Sale] jQuery - ✗ Condition 1: compare_at_price is falsy');
        }
      } else {
        console.log('[Final Sale] jQuery - ✗ Condition 1: No variant found');
      }
      
      // Check if selected color is in sale_colors array
      if (!shouldShow && selectedColor && saleColors.length > 0) {
        console.log('[Final Sale] jQuery - Checking condition 2: color in sale_colors array');
        if (saleColors.includes(selectedColor)) {
          console.log('[Final Sale] jQuery - ✓ Condition 2: color in sale_colors is TRUE');
          shouldShow = true;
        } else {
          console.log('[Final Sale] jQuery - ✗ Condition 2: color in sale_colors is FALSE');
        }
      } else {
        console.log('[Final Sale] jQuery - ✗ Condition 2: Skipped');
      }
      
      // Check if selected color has m-meta class
      if (!shouldShow) {
        console.log('[Final Sale] jQuery - Checking condition 3: m-meta class');
        const hasMeta = hasMetaClass();
        
        if (hasMeta) {
          console.log('[Final Sale] jQuery - ✓ Condition 3: m-meta class is TRUE');
          shouldShow = true;
        } else {
          console.log('[Final Sale] jQuery - ✗ Condition 3: m-meta class is FALSE');
        }
      } else {
        console.log('[Final Sale] jQuery - ✗ Condition 3: Skipped');
      }
      
      // Show or hide Final Sale span
      console.log('[Final Sale] jQuery - Final decision - shouldShow:', shouldShow);
      if (shouldShow) {
        console.log('[Final Sale] jQuery - Showing Final Sale span');
        finalSaleSpan.style.display = 'block';
      } else {
        console.log('[Final Sale] jQuery - Hiding Final Sale span');
        finalSaleSpan.style.display = 'none';
      }
      
      console.log('[Final Sale] ===== jQuery variantChange complete =====');
    });
  } else {
    console.log('[Final Sale] jQuery variantChange listener not set up');
  }
  
  console.log('[Final Sale] Script initialization complete');
});

